module.exports = __webpack_public_path__ + "res/roboto-v15-latin-300.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-300.woff
// module id = 97
// module chunks = 1